<div class="sp-width__full sp-min-height__full sp-column">
  <app-settings-data-table
    *ngIf="settings.length"
    [settings]="settings"
    class="sp-width__full"></app-settings-data-table>
</div>
